import { ofType } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { NavigationEvents, isNavigationAction } from 'src/components/NavigationListener/types';

import { isSubscribedUser } from '../../is-subscribed-user';

import { CustomerInfo, isCustomerInfo } from './types';

/**
 * Logged in users use the Checkout `setStep` event
 * to trigger the start checkout event.
 */
export function loggedInUsersEpic(action$, state$): Observable<CustomerInfo> {
    return action$.pipe(
        ofType(NavigationEvents.NAVIGATION_COMPLETE),

        // Only trigger when the user navigates to the checkout page
        filter((action) => isNavigationAction(action) && action.payload.pathname.startsWith('/checkout')),

        withLatestFrom(state$),

        filter(([, state]) => isSubscribedUser(state)),

        map(([, state]: [unknown, any]) => {
            const user = state.user ?? {};

            const email = user.data?.email;
            const firstName = user.data?.firstname ?? undefined;
            const lastName = user.data?.lastname ?? undefined;

            if (email && firstName && lastName) {
                const customerInfo: CustomerInfo = {
                    email,
                    firstName,
                    isGuest: false,
                    lastName,
                };

                return customerInfo;
            }

            return null;
        }),

        // Filter out null values
        filter(isCustomerInfo),
    );
}
